import { render, staticRenderFns } from "./ReportTablesWrapper.vue?vue&type=template&id=2da4c400"
import script from "./ReportTablesWrapper.vue?vue&type=script&lang=js"
export * from "./ReportTablesWrapper.vue?vue&type=script&lang=js"
import style0 from "./ReportTablesWrapper.vue?vue&type=style&index=0&id=2da4c400&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports